module.exports = __webpack_public_path__ + "static/media/tachometer-alt.cfa77318.svg";